import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/quiz/client/QuizClient.tsx");
